<template>
  <div>

      <v-progress-linear indeterminate v-if="loading" class="ma-2" />

      <v-card v-for="task in displayTasks" :key="task.xid" class="my-2" elevation="2" :disabled="loading">
        <v-list dense>
          <v-list-item>
            <v-list-item-content style="flex: 0 0 content;" class="font-weight-medium mx-1">
              <router-link :to="`/dash/jobs/all/${task.jobId}`" class="text-decoration-none">
                <span class="font-weight-medium mr-2" :class="task.dependentsCompleted ? 'primary--text' : 'warning--text'">{{ task.jobNumber }}</span>
              </router-link>
            </v-list-item-content>

            <v-list-item-content class="mx-1">
              <div>
                <v-chip label outlined class="mb-0" small>{{ task.type?.title }}</v-chip>
                <span class="mx-2 caption">{{ task.custName }}</span>
              </div>
              <div v-if="task.description">
                <span class="mr-2 text-subtitle-2">{{ task.description }}</span>
              </div>
            </v-list-item-content>
            

            <v-list-item-content style="flex: 0 0 content;" class="text-subtitle-2 mx-2" v-if="taskAge(task.jobPromised)">
              <div><v-icon>mdi-calendar</v-icon>{{ taskAge(task.jobPromised) }}</div>
            </v-list-item-content>
            <v-list-item-content style="flex: 0 0 content;" class="font-weight-medium mx-2">
              {{ duration(task.duration) }}
            </v-list-item-content>
            <v-list-item-content style="flex: 0 0 content;" class="font-weight-medium mx-2">
              <v-btn icon large @click="clickCompleteTask(task)"><v-icon color="primary">mdi-check</v-icon></v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>

      <v-dialog v-model="completeTaskDialog.show" max-width="90vw" width="800" loading persistent>
        <v-card :loading="completeTaskDialog.loading" :disabled="completeTaskDialog.loading">
          <v-card-title class="primary white--text">Complete Task</v-card-title>
          <v-card-text class="mt-4">
            <v-row>
              <v-col>
                <span class="font-weight-medium mr-2" :class="true ? 'primary--text' : 'warning--text'">{{ completeTaskDialog.task?.jobNumber }}</span>
                <v-chip label outlined class="mb-0" small>{{ completeTaskDialog.task?.type?.title }}</v-chip>
                <span class="mx-2 caption">{{ completeTaskDialog.task?.custName }}</span><br>
                <span class="mr-2 text-subtitle-2">{{ completeTaskDialog.task?.description }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea v-model="completeTaskDialog.notes" outlined placeholder="Completion notes" hide-details />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer />
            <v-btn class="secondary" @click="completeTaskDialog.show = false">Cancel</v-btn>
            <v-btn class="primary" @click="completeTask">Complete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>

<script>
import { /* mapGetters, */  mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'Listing',
  components: {

  },

  props: {
    scheduleId: { type: String, required: true },
    availability: { type: String, required: false, default: "all" }, // all/available/unavailable
  },

  data(){
    return {
      loading: false,
      tasks: [],
      completeTaskDialog: {
        show: false,
        loading: false,
        task: null,
        notes: null,
      }
    }
  },

  computed: {
    displayTasks(){
      if(this.availability == "available")
        return this.tasks.filter(t => t.dependentsCompleted == true)
      if(this.availability == "unavailable")
        return this.tasks.filter(t => t.dependentsCompleted == false)
      return this.tasks;
    },
  },

  methods: {
    ...mapActions('API', ['API']),
    ...mapActions('UI', ['CONFIRM']),
    
    refresh(){
      this.loading = true;
      this.API({ endpoint: `schedules/${this.scheduleId}/tasks` })
      .then(data => {
        this.tasks = data;
      })
      .finally(() => { this.loading = false; })
    },

    //duration(minutes){ return Moment.duration(minutes, 'minutes').humanize({ m: 60, h: 24 }); },

    completeTask(){
      this.completeTaskDialog.loading = true;
      let data = { notes: this.completeTaskDialog.notes };
      this.API({ method: 'POST', endpoint: `tasks/${this.completeTaskDialog.task.xid}/complete`, data })
      .then(() => {
        this.completeTaskDialog.show = false;
      })
      .then(this.refresh);
    },

    duration(minutes) {
      var h = Math.floor(minutes / 60);
      var m = String(minutes - (h * 60)).padStart(2, '0');
      return `${h}:${m}`;
    },

    taskAge(promiseDate) {
      if(promiseDate == null) return null;
      return moment(promiseDate).diff(moment(), 'days');
    },

    clickCompleteTask(task){
      this.completeTaskDialog.task = task;
      this.completeTaskDialog.notes = null;
      this.completeTaskDialog.show = true;
      this.completeTaskDialog.loading = false;
    },

  },
  mounted(){ this.refresh(); },
}
</script>
